// eslint-disable-next-line
import { BlankLayout } from "@/layouts";

export const asyncRouterMap = [
  {
    path: "/",
    component: BlankLayout,
    redirect: "/devices",
  },
  // children: [
  // {
  //   path: '/index',
  //   name: 'Index',
  //   component: () => import('@/views/Index'),
  // children:[
  {
    path: "/devices",
    name: "Devices",
    component: () => import("@/views/Device"),
  },
  {
    path: "/books",
    name: "Books",
    component: () => import("@/views/Books"),
  },
  {
    path: "/book",
    name: "Book",
    component: () => import("@/views/book/Book"),
  },
  {
    path: "/center",
    name: "Center",
    component: () => import("@/views/Center"),
  },
  {
    path: "/bookmanager",
    name: "BookManager",
    component: () => import("@/views/accout/BookManager"),
  },
  {
    path: "/edit_info",
    name: "EditInfo",
    component: () => import("@/views/accout/EditInfo"),
  },
  {
    path: "/rule",
    name: "Rule",
    component: () => import("@/views/accout/Rule"),
  },
  {
    path: "/collect",
    name: "Collect",
    component: () => import("@/views/accout/Collect"),
  },
  {
    path: "/against_record",
    name: "AgainstRecord",
    component: () => import("@/views/accout/AgainstRecord"),
  },
  {
    path: "/accout",
    name: "Accout",
    component: () => import("@/views/accout/Accout"),
  },
  {
    path: "/question",
    name: "Question",
    component: () => import("@/views/accout/Question"),
  },
  {
    path: "/question_edit",
    name: "QuestionEdit",
    component: () => import("@/views/accout/QuestionEdit"),
  },
  {
    path: "/bind_card",
    name: "BindCard",
    component: () => import("@/views/accout/BindCard"),
  },
  {
    path: "/bind_id",
    name: "BindId",
    component: () => import("@/views/accout/BindId"),
  },
  {
    path: "/face",
    name: "Face",
    component: () => import("@/views/accout/Face"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login"),
  },
  {
    path: "/wechat",
    name: "Wechat",
    component: () => import("@/views/WechatOauth"),
  },
  {
    path: "/wechatBindCard",
    name: "WechatBindCard",
    component: () => import("@/views/WechatBindCard"),
  },
  // ]
  // },

  // ]
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];
